import Vue from 'vue';
import axios from 'axios';

export class Rastreador{

    static create(){

        return {
            id_rastreador: null,
            cod_externo: null,
            serial : null,
            cod_fab_rastreadores : null,
            ign_input1: false,
            ign_virtual: false,
            input1: 'SENSOR',
            input2: 'SENSOR',
            output1: 'NORMAL',
            id_sensor_temperatura: null,
            cod_modelo : null,
            tipo_hodometro: 'KM',
            usar_gmt: false,
            gmt: -3,
            senha: 123456,
            id_chip : null,
            bateria_voltagem: true,
            id_acessarios : null
        };

    }

    static lasts (id_rastreador) {
        return new Promise((resolve, reject) => {
            Vue.http.get('posicoes/lasts/' + id_rastreador)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static grid(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/rastreadores')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static gridv2(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/v2/rastreadores')
                .then((res) => ok(res.data.rows))
                .catch((err) => fail(err));
        });
    }

    static gridDescartados(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/rastreadores-descartados')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param id_rastreador
     * @return {Promise}
     */
    static remove(id_rastreador){
        return new Promise((ok, fail) => {
            Vue.http.delete('rastreador/by-pk/'+ id_rastreador)
                .then(() => ok())
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param id_rastreador
     * @param json
     * @return {Promise}
     */
    static descartar(id_rastreador, json){
        return new Promise((ok, fail) => {
            Vue.http.put('rastreador/descartar/'+ id_rastreador, json)
                .then(() => ok())
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static gridRastreamento(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/rastreamento')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static gridRastreamentoV2(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/v2/rastreamento')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param {number|null} [since]
     * @return {Promise}
     */
    static gridRastreamentoSimples(since){
        return axios.get('grid/v5/rastreamento/simples', {
            timeout: 15000,
            params: since ? { since } : undefined
        }).then((res) => res.data);
    }

    /**
     *
     * @param {number|null} [since]
     * @return {Promise}
     */
    static gridRastreamentoV3(since){
        return axios.get('grid/v3/rastreamento', {
            timeout: since ? 15000 : 45000,
            params: since ? { since } : undefined
        }).then((res) => res.data);
    }

    static async gridRastreamentoSimplesV2(){
        return new Promise((resolve, reject) => {
            axios.get('grid/v2/rastreamento/simples', {
                timeout: 15000
            })
                .then((res) => resolve(res.data.rows))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static gridRastreamentoClientes(){
        return new Promise((ok, fail) => {
            Vue.http.get('grid/rastreamento/clientes')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param id_rastreador
     * @returns {Promise}
     */
    static combo(id_rastreador){
        return new Promise((ok, fail) => {
            Vue.http.get('rastreador/disponiveis/'+ id_rastreador)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param idRastreador
     * @returns {Promise}
     */
    static byPK(idRastreador){
        return new Promise((ok, fail) => {
            Vue.http.get('rastreador/by-pk/' + idRastreador)
                .then((res) => ok(res.data))
                .catch(() => fail());
        });
    }

    /**
     *
     * @param idRastreador
     * @returns {Promise}
     */
    static getLastPosition(idRastreador){
        return new Promise((ok, fail) => {
            Vue.http.get('api/v2/rastreador/' + idRastreador + '/last-position')
                .then((res) => ok(res.data))
                .catch(() => fail());
        });
    }

    static subscribeLastPositionStream(idRastreador, { onPosition, onError, onLocalization } = {}) {
        const token = window.localStorage.getItem('token');
        const url = window.URL + '/api/v2/rastreador/' + idRastreador + '/last-position/stream?token=' + token;
        const source = new EventSource(url);

        source.addEventListener('position', (event) => {
            if (onPosition) {
                onPosition(JSON.parse(event.data));
            }
        });

        source.addEventListener('localization', (event) => {
            let localization = JSON.parse(event.data);
            if (localization.localization && onLocalization) {
                onLocalization(localization.localization);
            }
        });

        source.onerror = () => {
            if (onError) {
                onError();
            }
            source.close();
            console.error('Erro no stream de last-position');
        };

        return source;
    }

    /**
     *
     * @param idRastreador
     * @returns {Promise}
     */
    static ibuttons(idRastreador){
        return new Promise((ok, fail) => {
            Vue.http.get('api/v1/rastreador/' + idRastreador + '/ibuttons')
                .then((res) => ok(res.data))
                .catch(() => fail());
        });
    }

    static sendOutputs(idRastreador, json){
        return new Promise((ok, fail) => {
            Vue.http.put('api/v1/rastreador/' + idRastreador + '/outputs', json)
                .then((res) => ok(res.data))
                .catch(() => fail());
        });
    }

    /**
     *
     * @param json
     * @returns {Promise}
     */
    static save(json){
        return new Promise((ok, fail) => {

            let promise = null;

            if (json.id_rastreador){
                promise = Vue.http.put('rastreador/by-pk/'+ json.id_rastreador, json);
            } else {
                promise = Vue.http.post('rastreador/by-pk/'+ json.id_rastreador, json);
            }

            promise
                .then((res) => ok(res.data))
                .catch((err) => fail(err));

        });
    }

    /**
     *
     * @param fab
     * @returns {Promise}
     */
    static modeloByFabricante(fab){
        return new Promise((ok, fail) => {
            Vue.http.get('modelo_rastreador/by-fab/' + fab)
                .then((res) => ok(res.data))
                .catch(() => fail());
        });
    }

}
